import type { ParcellingMaturationCycle } from '../types';

export const MATURATION_CYCLE_OPTIONS: { value: ParcellingMaturationCycle; label: string }[] = [
	{ value: 'early', label: 'Precoce' },
	{ value: 'medium', label: 'Médio' },
	{ value: 'late', label: 'Tardio' },
];
